import { useEffect, useRef, useState } from "react";
import Icon from "../Icon/Icon";
import styles from "./copyToClipboardButton.css.ts";

function CopyToClipboardButton({ value }) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef(null);

  function handleCopyToClipboard(e) {
    if (!window.isSecureContext) return;

    navigator.clipboard.writeText(e.currentTarget.dataset.value);

    setCopied(true);

    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set new timeout and store reference
    timeoutRef.current = setTimeout(() => {
      setCopied(false);
      timeoutRef.current = null;
    }, 2000);
  }

  const iconName = copied ? "copied" : "copy";

  // Clean up, in case the user somehow navigates away while the timer is running.
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      className={styles.clipboard}
      onClick={handleCopyToClipboard}
      data-value={value}
    >
      <code className={styles.code({ copied })}>{value}</code>

      <Icon name={iconName} className={styles.icon({ copied })} size="32px" />
    </div>
  );
}

export default CopyToClipboardButton;
